module.exports = __webpack_public_path__ + "static/media/kn.0c9fdc14.svg";